import React from 'react';

function Experience() {
  return (
    <section className="tc-experience-style1 section-padding-x">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-2">
            <div className="exp-num mb-100 wow zoomIn" data-wow-delay="0.3s">
              <h5 className="fsz-18 text-uppercase">
                juntos <br /> desde
              </h5>
              <h2 className="num"> 1994 </h2>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="img wow">
              <img
                src="/home1/assets/img/exp.png"
                alt=""
                className="img-cover"
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="info wow fadeInUp" data-wow-delay="0.3s">
              <h3 className="fsz-45 fw-600 mb-30"> Nossas Origens </h3>
              <div className="text fsz-15 color-666">
                A Perlare tem sua história baseada na Imigração Italiana, que ocorreu no Brasil entre 1880 e 1930. Foi na colônia italiana, que hoje chama-se cidade de Bento Gonçalves - RS, que os descendentes do artesão em madeira, Romano De Paris, firmaram as suas raízes. A empresa nasceu em 1994, acompanhando a consolidação do polo moveleiro de Bento, cresceu tendo sua localização em uma região inspiradora denominada Caminhos de Pedra. No trajeto são encontrados restaurantes temáticos, prédios históricos e diversas atrações, que reforçam o posicionamento e origem da Perlare. Assim é a casa da Perlare. Ano após ano, a Perlare conquista seu espaço no mercado moveleiro, de construção civil, arquitetura e decoração, e torna-se referência em seu segmento, graças à pesquisa, desenvolvimento, tecnologia e confiabilidade na qualidade dos seus produtos.
              </div>
              <a
                href="/sobre"
                className="butn rounded-pill mt-50 hover-bg-black bg-white"
              >
                <span>
                  Conheça Mais <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="rotate-txt justify-content-lg-end">
              <ul>
                <li>
                  <a href="mailto:perlare@perlare.com"> perlare@perlare.com </a>
                </li>
                <li>
                  <a href="tel:+555421029191"> (54) 2102-9191</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Experience;
